import { Moment } from 'moment';

export interface ILog {
  id?: number;
  action?: string;
  details?: string;
  timestamp?: Moment;
}

export const defaultValue: Readonly<ILog> = {};
